import { render, staticRenderFns } from "./k-form.vue?vue&type=template&id=d96291f4&lang=pug&"
import script from "./k-form.vue?vue&type=script&lang=js&"
export * from "./k-form.vue?vue&type=script&lang=js&"
import style0 from "./k-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d96291f4')) {
      api.createRecord('d96291f4', component.options)
    } else {
      api.reload('d96291f4', component.options)
    }
    module.hot.accept("./k-form.vue?vue&type=template&id=d96291f4&lang=pug&", function () {
      api.rerender('d96291f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/blocks/k-form.vue"
export default component.exports